function round2decimals(num: number) {
	return Math.round((num + Number.EPSILON) * 100) / 100
}

export const PaymentHelper = {
	round2decimals,
}
